import { Error404RoutingModule } from './error404-routing.module';
import { Eroor404Component } from './eroor404.component';
// import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [
    Error404RoutingModule,
    HttpClientModule,
    CommonModule,
    // LoadingModule
  ],
  declarations: [Eroor404Component],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class Error404Module { }
